<template>
  <div v-if="selectedPlanObj">
    <div>
      <ul :class="s.confirmList">
        <li>
          <p :class="s.itemname">プラン</p>
          <div :class="s.detail">
            <p>
              <span>{{ selectedPlanObj.label }}</span>
              <span :class="s.price">&yen;{{ addComma(courseData[selectedCourse].unit_amount) }}/{{ selectedPlanObj.term }}</span>
            </p>
          </div>
        </li>
        <li>
          <p :class="s.itemname">お支払い方法</p>
          <div :class="s.detail" v-if="customerDefaultSource">
            <div :class="s.credit_card">
              <div
                :class="s.card_img"
                v-bind:style="{ 'background-image':`url('/img/cards/${getCardIconName(customerDefaultSource?.brand)}.png')`}"></div>
              <p>**** **** **** {{ customerDefaultSource?.last4 }}</p>
            </div>
          </div>
        </li>
        <li v-if="['webPaper', 'paper'].includes(coursename)">
          <p :class="s.itemname">配送先</p>
          <div :class="s.detail" v-if="deliveryAddress">
            <p>{{ deliveryAddress.label }}</p>
          </div>
        </li>
        <li>
          <p :class="s.itemname">既存紙面配達契約の解約</p>
          <div v-if="!cancelData.name" :class="s.detail">なし</div>
          <div v-else :class="s.detail">
            <p>契約者氏名：{{ cancelData.name  }}</p>
            <p>契約者住所：{{ cancelData.address }}</p>
            <p>契約者電話番号：{{ cancelData.tel }}</p>
            <p>現在の支払い方法：{{ cancelData.method }}</p>
          </div>
        </li>
      </ul>
      <Spacer :y="6"/>
      <div :class="[styleClasses.btns, s.btns]">
        <button
          :class="[styleClasses.btn, styleClasses.secondary]"
          @click="toBack()">戻る</button>
        <Spacer :x="2"/>
        <button
          :class="[styleClasses.btn, styleClasses.primary ]"
          @click="submit">申し込みを確定する</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import Spacer from '@/components/Spacer.vue';

export default {
  name: 'edit-subscription-confirm',
  mixins: [cf],
  components: {
    Spacer,
  },
  props: {
    selectedCourse: String || null,
    customerDefaultSource: Object || null,
    deliveryAddress: Object || null,
    styleClasses: Object,
    courseData: Object || null,
    cancelData: Object,
  },
  data() {
    return {
      methodLabels: {
        bank: '銀行引き落とし',
        collection: '集金',
        other: 'その他',
        unknown: '不明',
      },
    };
  },
  created() {
    if (!this.selectedCourse) this.$router.push('/edit/subscription/');
    else if (!this.customerDefaultSource) this.$router.push('/edit/subscription/payment-method/');
    else if (!this.deliveryAddress && this.selectedCourse.toLowerCase().includes('paper')) this.$router.push('/edit/subscription/delivery-address/');
  },
  computed: {
    ...mapState(['user', 'helper']),
    selectedPlanObj() {
      return this.helper.master.products?.plans?.[this.selectedCourse] || null;
    },
  },
  methods: {
    toBack() {
      if (this.selectedCourse.toLowerCase().includes('paper')) this.$router.push('/edit/subscription/delivery-address/');
      else this.$router.push('/edit/subscription/payment-method/');
    },
    submit() {
      this.$emit('registSubscription');
    },
  },
};
</script>

<style lang="scss" module="s">
.confirmList {
  border: 1px solid var(--gray);
}

.itemname {
  background-color: var(--lightgray);
  padding: 4px 10px;
  font-size: 12px;
  font-weight: bold;
}

.detail {
  padding: 12px 16px;
}

@include sm-view {
  .btns {
    flex-direction: column-reverse;
    > * {
      margin-left: 0 !important;
    }
  }
}
</style>
